import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import NotFound from "./NotFound";

const UserProtectedRoute = ({ children }) => {
  const isAdmin = sessionStorage.getItem("isAdmin") === "true";
  const name = sessionStorage.getItem("name");
  const location = useLocation();

  // Not logged in → Login
  if (!name) {
    return <Navigate to="/login" replace />;
  }

  // Non-admin trying to access merchant list → Block
  if (!isAdmin && location.pathname === "/merchant-list") {
    return <NotFound />;
  }

  // Otherwise allowed
  return children;
};

export default UserProtectedRoute;
